import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Snowflake, X } from "lucide-react";

export const WinterFlyer = () => {
  const [visible, setVisible] = useState(true);

  return (
    <AnimatePresence>
      {visible && (
        <motion.aside
          initial={{ opacity: 0, y: -18, rotate: 3, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, rotate: 1.5, scale: 1 }}
          exit={{ opacity: 0, scale: 0.85, transition: { duration: 0.2 } }}
          transition={{ type: "spring", stiffness: 260, damping: 20, delay: 1.2 }}
          className="animate-floaty fixed right-3 top-20 z-40 w-60 rounded-3xl border-2 border-sky-200 bg-white/95 p-5 shadow-2xl shadow-sky-500/25 backdrop-blur-md sm:right-5 sm:top-24 sm:w-64"
          data-testid="winter-hours-flyer"
          aria-label="New winter hours announcement"
        >
          <button
            type="button"
            onClick={() => setVisible(false)}
            aria-label="Dismiss winter hours announcement"
            data-testid="winter-flyer-close"
            className="absolute -left-2 -top-2 flex h-8 w-8 items-center justify-center rounded-full bg-sky-500 text-white shadow-md transition-colors hover:bg-sky-600 focus:outline-none focus:ring-4 focus:ring-sky-300"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </button>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sky-100">
              <Snowflake className="h-5 w-5 text-sky-500" aria-hidden="true" />
            </span>
            <p className="font-display text-base font-semibold text-sky-700">New Winter Hours!</p>
          </div>
          <div className="mt-3 space-y-1.5 text-sm font-bold text-slate-700">
            <p>
              <span className="text-red-500">Closed:</span> Mon • Tue • Wed • Thu
            </p>
            <p>
              <span className="text-green-600">Open:</span> Fri • Sat • Sun
            </p>
            <p className="rounded-2xl bg-sky-50 px-3 py-2 text-center font-display text-lg font-semibold text-sky-700" data-testid="winter-flyer-times">
              2:30 PM – 5:30 PM
            </p>
          </div>
          <p className="mt-3 text-center text-xs font-extrabold uppercase tracking-widest text-slate-500">
            See y'all this weekend!
          </p>
        </motion.aside>
      )}
    </AnimatePresence>
  );
};
